import {IEvent} from "../../../models/eventModel";
import {CalendarAction, CalendarActionsEnum} from "./types";
import {AppDispatch} from "../../index";
import {CalendarService} from "../../../api/CalendarService";

export const CalendarActionCreators = {
    setEvents: (events: IEvent[]): CalendarAction => ({type: CalendarActionsEnum.SET_EVENTS, payload: events}),
    setIsLoading: (isLoading: boolean): CalendarAction => ({
        type: CalendarActionsEnum.SET_IS_LOADING,
        payload: isLoading
    }),
    setNearestTournament: (event: IEvent): CalendarAction => ({
        type: CalendarActionsEnum.SET_NEAREST_TOURNAMENT,
        payload: event,
    }),
    fetchEvents: () => async (dispatch: AppDispatch) => {
        try {
            dispatch(CalendarActionCreators.setIsLoading(true))
            const response = await CalendarService.getEvents()
            const events = response.data.events
            dispatch(CalendarActionCreators.setEvents(events))
            if (response.data.nearest_tournament) {
                dispatch(CalendarActionCreators.setNearestTournament(response.data.nearest_tournament))
            }
            dispatch(CalendarActionCreators.setIsLoading(false))

        } catch (e) {
            console.error(e)
        }
    }
}
